<template>
	<div class="events">
		<fluke-card>
			<header>
				<div class="title">
					Newsletter
				</div>
				<div class="description">
					Lista de emails cadastrados
				</div>
			</header>
			<main>
				<v-data-table
					:headers="headers"
					:items="news"
					:search="search"
					:rows-per-page-items="[5,10,50]"
					rows-per-page-text="Linhas pos página"
					class="inner-tables">

					<template v-slot:items="props">
						<td>{{ props.item.email }}</td>
						<td>{{ props.item.createdAt }}</td>
					</template>
					<template v-slot:no-results>
						<v-alert
							:value="true"
							color="error"
							icon="warning">
							Sua busca por "{{ search }}" não achou nenhum resultado.
						</v-alert>
					</template>
				</v-data-table>
				<div class="flexsplit">
					<div class="searchtable">
						<v-text-field
							v-model="search"
							append-icon="search"
							label="Pesquise"
							single-line
							hide-details>
						</v-text-field>
					</div>
					<div></div>
				</div>
			</main>
			<footer>
				<download-excel
					class   = "fluke-btn export-btn"
					:data   = "news"
					worksheet = "Contact Worksheet"
					name    = "newsletter.xls">

					<i class="material-icons">get_app</i>
					Download XLS

				</download-excel>
			</footer>
		</fluke-card>
	</div>
</template>

<script>
import axios from 'axios';
import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';


export default {
	components: {
		'fluke-card': Card,
		'fluke-button': Button
	},
	data: function() {
		return {
			news: [],
			headers: [
				{
					text: "Email",
					align: 'left',
					value: 'email'
				},
				{
					text: "Data",
					align: 'left',
					value: 'orignalCreatedAt'
				}
			],
			search: ''
		}
	},
	created: function() {
		this.get();
	},
	methods: {
		get: async function() {
            const result = await axios.get( this.$myServerAddresses.newsletter + 'news', {
                headers: {
                    'X-Fluke': this.$cookies.get('token')
                }
            })
			this.news = result.data.map( elem => {
				var newData = elem.createdAt.slice(0,-8).split('T');
                elem.orignalCreatedAt = elem.createdAt;
				elem.createdAt = newData[0].split('-').reverse().join('/') + ' ' + newData[1];
				return elem;
			});
		}
	}
}
</script>

<style lang="scss">

</style>


